import React from 'react';
import {Route} from 'react-router-dom';
import {Wrapper} from '../hooks/common';
import {Create, List} from '../hooks/custommargin/';

export default [
  <Route path="/custom_margins/create/:id" component={props => <Wrapper component={Create} {...props} />} exact key="create" />,
  <Route path="/custom_margins" component={props => <Wrapper component={List} {...props} />} exact strict key="list" />,
  <Route path="/custom_margins/:page" component={props => <Wrapper component={List} {...props} />} exact strict key="page" />
];